









































import { ChainModule } from '@/store/modules/chain.module'
import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { ITrainingMilestoneTemplate } from '@zunta/configurations'
import MilestonesBlock from '../components/MilestonesBlock.vue'
import AddEditTemplateModal from '../components/AddEditTemplateModal.vue'
import Icon from '@/components/Icon.vue'
import Card from '@/components/Card.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import FileUploadLabel from '@/components/labels/FileUploadLabel.vue'
import api from '@/api'

const groupBy = require('lodash.groupby')
const sortBy = require('lodash.sortby')

@Component({
  components: {
    InputV2,
    Card,
    Icon,
    LoaderWrapper,
    MilestonesBlock,
    AddEditTemplateModal,
    FileUploadLabel
  }
})
export default class UsersMilestones extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  isLoading: boolean = true
  searchMilestone: string = ''
  isWantAddTemplate: boolean = false

  get milestoneTemplates () {
    return this.$store.state.chain.trainingTemplates
  }

  get displayTemplate () {
    return this.milestoneTemplates.filter((template: ITrainingMilestoneTemplate) => {
      if (!template.parent) {
        return true
      }
      return new RegExp(`${this.searchMilestone}`, 'i').test(template.milestone)
    })
  }

  get milestonesList () {
    const group: { [k: string]: ITrainingMilestoneTemplate[] } = groupBy(this.displayTemplate, (template: ITrainingMilestoneTemplate) => {
      return template.parent
    })
    const items: any[] = []
    const map: any = {}
    Object.keys(group).forEach((key) => {
      const parent: ITrainingMilestoneTemplate = this.displayTemplate.find((template: ITrainingMilestoneTemplate) => template.id === +key)
      if (parent) {
        map[parent.id] = true
        const item = {
          parent,
          subTemplates: sortBy(group[key], (template: ITrainingMilestoneTemplate) => template.order)
        }
        items.push(item)
      }
    })
    if ((group['null'] || []).length !== Object.keys(map).length) {
      (group['null'] || []).forEach((template: ITrainingMilestoneTemplate) => {
        if (!map[template.id]) {
          items.push({
            parent: template,
            subTemplates: []
          })
        }
      })
    }
    return sortBy(items, (item: any) => item.parent.order)
  }

  mounted () {
    this.fetchTemplates()
  }

  async fetchTemplates () {
    this.isLoading = true
    await this.chainModuleInstance.fetchTrainingTemplates()
    this.isLoading = false
  }

  async addTemplate (name: string) {
    await this.chainModuleInstance.createTrainingTemplate({
      name
    })
    this.isWantAddTemplate = false
  }

  async importMilestones (file: any) {
    api.training.importMilestones(file)
  }
}
